export default __webpack_public_path__ + "static/media/butterfly2.f34b418e.png";